
export default {
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      yearsExample: [2022, 2023, 2024, 2025],
      yearSelected: 2025,
    };
  },
  methods: {
    handleYearChange(value) {
      this.$emit("handleYearChange", value);
    },
  },
};
